import React from 'react'
import Supplier from '../../Components/Suppliers/Supplier'

const SupplierPage = () => {
  return (
    <div><Supplier /></div>
  )
}

export default SupplierPage